import React from 'react';
import { getFlag } from "@/config/rdoFlags";
import { WorkforceModule } from "@/components/rdo/modules/WorkforceModule";
import { LegacyWorkforceSection } from "@/components/rdo/legacy/LegacyWorkforceSection";
import { normalizeFromRDOPAGE, toRDOPAGEPayload } from "@/domain/rdo/normalize";

interface WorkforceForRDOProps {
  legacyValue: any[];
  onLegacyChange: (value: any[]) => void;
  mode: "create" | "edit" | "view";
  // Legacy props for fallback
  rdoData: any;
  workforceViewMode: 'cards' | 'table';
  setWorkforceViewMode: (mode: 'cards' | 'table') => void;
  showWorkforceModal: boolean;
  setShowWorkforceModal: (show: boolean) => void;
  handleAddWorkforce: (data: any) => void;
  handleEditWorkforce: (index: number) => void;
  handleDeleteWorkforce: (index: number) => void;
  isEditing: boolean;
  isSectionEnabled: (section: string) => boolean;
}

export function WorkforceForRDO({
  legacyValue,
  onLegacyChange,
  mode,
  // Legacy props
  rdoData,
  workforceViewMode,
  setWorkforceViewMode,
  showWorkforceModal,
  setShowWorkforceModal,
  handleAddWorkforce,
  handleEditWorkforce,
  handleDeleteWorkforce,
  isEditing,
  isSectionEnabled
}: WorkforceForRDOProps) {
  
  if (!getFlag("useNewWorkforceInRDO")) {
    // Render legacy workforce section from RDO.tsx
    return (
      <LegacyWorkforceSection
        rdoData={rdoData}
        workforceViewMode={workforceViewMode}
        setWorkforceViewMode={setWorkforceViewMode}
        showWorkforceModal={showWorkforceModal}
        setShowWorkforceModal={setShowWorkforceModal}
        handleAddWorkforce={handleAddWorkforce}
        handleEditWorkforce={handleEditWorkforce}
        handleDeleteWorkforce={handleDeleteWorkforce}
        isEditing={isEditing}
        isSectionEnabled={isSectionEnabled}
      />
    );
  }

  // Use new unified schema with adapter
  const legacyRDO = {
    id: '',
    obraId: '',
    date: '',
    workforce: legacyValue,
    materials: { received: [], used: [] },  // formato antigo
    equipment: [],
    activities: [],
    occurrences: [],
    comments: [],
    photos: [],
    videos: [],
    attachments: [],
    status: 'draft' as const,
    createdAt: '',
    updatedAt: ''
  };
  
  const value = normalizeFromRDOPAGE(legacyRDO).workforce;

  return (
    <WorkforceModule
      value={value}
      mode={mode}
      onChange={(newValue) => {
        // Converter diretamente para o formato legacy esperado
        onLegacyChange(newValue);
      }}
    />
  );
}